import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion } from "framer-motion";
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from "react-icons/fa";
import "../styles/user/Contact.css";

export default function Contact() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <div className="contact-page">
      <Header />

      {/* Hero Section */}
      <section className="contact-hero">
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="hero-title">
            Liên hệ với <span className="highlight">SHome</span>
          </h1>
          <p className="hero-desc">
            Hãy để lại lời nhắn hoặc liên hệ trực tiếp với chúng tôi.
            <br />
            Chúng tôi luôn sẵn sàng hỗ trợ bạn 24/7.
          </p>
        </motion.div>
      </section>

      {/* Contact Info + Form */}
      <section className="contact-container">
        {/* Contact Info */}
        <motion.div
          className="contact-info"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Thông tin liên hệ</h2>
          <p className="info-item">
            <FaMapMarkerAlt className="icon" /> 60 Trần Đăng Ninh, P.Quang Trung,
            Q.Hà Đông, Hà Nội
          </p>
          <p className="info-item">
            <FaPhone className="icon" /> 0911 742 286
          </p>
          <p className="info-item">
            <FaEnvelope className="icon" /> support@shome.vn
          </p>
          <p className="info-item">
            <FaClock className="icon" /> Thứ 2 - Chủ Nhật: 8h00 - 22h00
          </p>

          {/* Google Map */}
          <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3725.67800109924!2d105.76745617502965!3d20.96544238066817!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x313452d9d15193db%3A0x105c3450735dda5a!2zNjAgUC5UcuG6p24gxJDEg25nIE5pbmgsIEjDoCBD4bqndSwgSMOgIMSQw7RuZywgSMOgIE7hu5lpIDEwMDAwLCBWaeG7h3QgTmFt!5e0!3m2!1svi!2s!4v1758080953371!5m2!1svi!2s"
            width="100%"
            height="300"
            className="map"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </motion.div>

        {/* Contact Form */}
        <motion.div
          className="contact-form"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          <h2 className="section-title">Gửi tin nhắn</h2>
          <form className="form">
            <motion.input
              type="text"
              placeholder="Họ và tên"
              className="input"
              whileFocus={{ scale: 1.02, borderColor: "#3b5998" }}
            />
            <motion.input
              type="email"
              placeholder="Email"
              className="input"
              whileFocus={{ scale: 1.02, borderColor: "#3b5998" }}
            />
            <motion.input
              type="tel"
              placeholder="Số điện thoại"
              className="input"
              whileFocus={{ scale: 1.02, borderColor: "#3b5998" }}
            />
            <motion.textarea
              placeholder="Nội dung"
              rows={5}
              className="textarea"
              whileFocus={{ scale: 1.02, borderColor: "#3b5998" }}
            />
            <motion.button
              type="submit"
              className="submit-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Gửi ngay
            </motion.button>
          </form>
        </motion.div>
      </section>

      <Footer />
    </div>
  );
}
